import styled, { keyframes } from "styled-components"

// Animación para la barra de progreso
const loadingBarAnimation = keyframes`
  0% { 
    background-position: 200% 0; 
  }
  100% { 
    background-position: -200% 0; 
  }
`

// Animación para el pulso del spinner
const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`

// Contenedor principal del loading
export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem;
  background-color: ${({ theme }) => theme.palette.white || "#f8f9fa"};
  border-radius: 12px;
  border: 2px solid ${({ theme }) => theme.palette.grey10 || "#e3f2fd"};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-height: 120px;
  width: 100%;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
`

// Barra de progreso animada
export const LoadingProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #2196f3, #21cbf3, #2196f3);
  background-size: 200% 100%;
  animation: ${loadingBarAnimation} 2s ease-in-out infinite;
`

// Contenedor del spinner con animación de pulso
export const SpinnerContainer = styled.div`
  animation: ${pulseAnimation} 2s ease-in-out infinite;
  filter: drop-shadow(0 2px 4px rgba(33, 150, 243, 0.3));
`

// Contenedor del texto
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`

// Texto principal del loading
export const LoadingMainText = styled.span`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary || "#1976d2"};
  text-align: center;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
`

// Texto secundario del loading
export const LoadingSubText = styled.span`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.palette.grey60 || "#666"};
  text-align: center;
  font-style: italic;
  transition: color 0.3s ease;
`

// Contenedor del mensaje de loading (wrapper original)
export const MessageLoadSim = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1.5rem;
`
